module.exports = __webpack_public_path__ + "img/cutaway_parked.5a38ab0b.svg";